'use client';

import AwardsSection from '@/app/(home)/components/award-section';
import BannerCarousel from '@/app/(home)/components/banner-carousel';
import EventBannerSection from '@/app/(home)/components/event-banner-section';
import PricingSection from '@/app/(home)/components/pricing-section';
import RecommendReviewSection from '@/app/(home)/components/recommend-review-section';
import SimulationSection from '@/app/(home)/components/simulation-section';
import StatsSection from '@/app/(home)/components/stats-section';
import WhySection from '@/app/(home)/components/why-section';
import PopBannerCarouselModal from '@/components/pop-banner-carousel-modal';
import { popupBannerData } from '@/data/main/popup.data';
import type { BannerItem } from '@/types/pop-banner-carousel-modal.type';
import { useEffect, useMemo, useState } from 'react';
import HeadSection from './components/head-section';
import HotBranchesSection from './components/hot-branches-section';
import PopupBannerCard from './components/popup-banner-card';

export default function Client() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // localStorage 체크 - 24시간이 지나지 않았으면 모달을 열지 않음
  useEffect(() => {
    const localStorageKey = 'pop-banner-carousel-hide-until';
    const hideUntil = localStorage.getItem(localStorageKey);

    if (hideUntil) {
      const hideUntilTimestamp = parseInt(hideUntil, 10);
      if (hideUntilTimestamp > Date.now()) {
        // 아직 24시간이 지나지 않았음
        setIsModalOpen(false);
        return;
      }
    }

    // 24시간이 지났거나 localStorage에 값이 없으면 모달 열기
    setIsModalOpen(true);
  }, []);

  // 팝업 배너 데이터를 BannerItem 형태로 변환
  const bannerItems: BannerItem[] = useMemo(
    () =>
      popupBannerData.map((banner) => ({
        id: banner.id,
        href: banner.href,
        content: <PopupBannerCard data={banner} />,
      })),
    [],
  );

  return (
    <>
      {/* 1. 헤더 */}
      <HeadSection />
      {/* 2. 배너 캐러셀 */}
      <BannerCarousel />
      {/* 3. 누적가입수, 합격률, 취득기간 등 통계 섹션 */}
      <StatsSection />
      {/* 4. 수상 내역 섹션 */}
      <AwardsSection />
      {/* 5. 왜 드라이빙존인가? 섹션 */}
      <WhySection />
      {/* 6. 운전시뮬레이션 섹션 */}
      <SimulationSection />
      {/* 7. 추천 리뷰 섹션 */}
      <RecommendReviewSection />
      {/* 8. 가격 섹션 */}
      <PricingSection />
      {/* 9. 이벤트 배너 섹션 */}
      <EventBannerSection />
      {/* 10. 가장 가까운 지점 섹션 */}
      <HotBranchesSection />
      {/* 11. 상담예약 배너 섹션 */}
      {/* <ReserveBanner /> */}

      {/* 팝업 배너 캐러셀 모달 */}
      <PopBannerCarouselModal
        banners={bannerItems}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        localStorageKey="pop-banner-carousel-hide-until"
        autoplayDelay={3000}
      />
    </>
  );
}
